module.exports = __webpack_public_path__ + "static/media/imobiliaria.1db1bd34.webp";